module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fyGSp"))).then(() => parcelRequire('iDabs'));